import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";

export class Images3dController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.images3d;
  }

  saveBlobAsScreenshot = (blob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result;
      this.addResource(base64data);
    };
    reader.readAsDataURL(blob);
  }
}

